import React, { useContext } from "react";
import { AppContext } from "../../contexts/AppContext";
import { useAuthContext } from "../../contexts/AuthContext";
import ClientApiKeysManager from "../../components/ApiKeys/ClientApiKeysManager";
import { resolveClientPublicId } from "../../utils/clientApiKeys";

/**
 * Client-level API keys: the client's own keys. Client admins are scoped server-side, so no
 * client id is required here.
 */
export const ApiKeys = () => {
  const { selectedClient, clients } = useContext(AppContext);
  const { activeUser } = useAuthContext();

  const clientId = resolveClientPublicId({ selectedClient, activeUser, clients });

  return <ClientApiKeysManager scope="client" clientId={clientId} />;
};

export default ApiKeys;
